module.exports = __webpack_public_path__ + "static/media/activity.e37d64d4.png";